import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import DownloadIcon from '@atlaskit/icon/glyph/download';
import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';

// @source
import { extensions as constant } from '../../../../constants';
import { Messages, Fragment } from '../../../components';
import { Report as APIs } from '../../../../server';

const initialState = {
  isLoading: false,
  message: false,
};

class DownloadDropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onClickHandle(file) {
    this.setState({
      isLoading: true,
    });

    APIs.download({
      data: {
        ...this.props.model,
        file,
      },
      success: () => {
        this.setStateUnmount({
          isLoading: false,
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    return (
      <Fragment>
        <DropdownMenu
          trigger={(
            <Button
              iconBefore={<DownloadIcon size="small" />}
              isDisabled={this.props.isDisabled}
              isLoading={this.state.isLoading}
            >
              Download file
            </Button>
          )}
        >
          <DropdownItem onClick={() => this.onClickHandle(constant.XLS)}>
            Send to .xlsx
          </DropdownItem>
          <DropdownItem onClick={() => this.onClickHandle(constant.CSV)}>
            Send to .csv
          </DropdownItem>
        </DropdownMenu>
        {this.state.message}
      </Fragment>
    );
  }
}

DownloadDropdownMenu.propTypes = {
  model: PropTypes.shape().isRequired,
  isDisabled: PropTypes.bool,
};

DownloadDropdownMenu.defaultProps = {
  isDisabled: false,
};

export default DownloadDropdownMenu;
